var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _rect, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStudentMoreTime = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1473,
  height: 1276,
  viewBox: "0 0 1473 1276",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M606.692 380.202C608.934 405.21 618.49 431.924 640.233 444.063C666.51 458.736 699.418 446.744 725.061 430.998C765.672 406.136 800.286 372.646 835.436 340.374C882.189 297.475 931.087 256.185 983.544 220.793C1033.51 187.059 1092.46 163.562 1153.44 167.413C1181.28 169.168 1209.46 176.87 1231.55 194.127C1271.47 225.278 1284.05 280.949 1283.32 331.94C1282.3 398.531 1260.89 455.324 1238.57 516.308C1214.97 580.803 1188.35 644.128 1158.9 706.088C1116.25 795.785 1062.47 887.58 974.379 931.941C946.736 945.883 912.659 954.17 885.748 938.863C859.568 923.995 848.599 891.382 846.307 861.158C843.967 830.885 848.014 800.075 841.92 770.387C840.36 762.831 837.922 755.031 832.316 749.864C818.665 737.336 796.873 747.378 782.442 758.98C745.927 788.278 716.676 825.62 683.866 859.062C651.056 892.503 612.688 923.117 567.154 933.404C521.668 943.69 467.993 928.675 444.299 888.067C421.435 848.824 431.38 798.662 418.802 754.934C416.364 746.452 412.854 737.921 406.419 731.924C393.207 719.64 372.439 721.833 355.376 727.391C300.725 745.233 255.483 789.497 198.638 797.54C175.53 800.807 149.838 796.809 133.506 779.991C119.075 765.122 114.492 742.552 117.076 721.882C121.22 688.343 140.623 660.264 156.955 631.648C174.799 600.351 192.788 569.103 211.216 538.148C248.024 476.286 286.635 415.447 329.001 357.29C360.543 314.001 394.426 271.979 435.183 237.465C455.22 220.5 477.255 205.193 502.265 197.491C536.294 186.961 571.834 192.665 590.994 225.327C619.124 273.295 601.963 327.943 606.692 380.202Z",
  fill: "#D6DAE0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M115.742 658.739L0.392578 869.096L265.72 1014.81L381.07 804.45L115.742 658.739Z",
  fill: "#F4F5F7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M77.3936 831.782L137.265 722.631",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M85.6748 861.364L165.527 715.852",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M104.559 871.704L184.342 726.191",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M123.377 895.042L203.16 749.529",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M199.874 925.243L231.486 867.654",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M212.943 932.432L244.556 874.774",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M226.014 939.555L257.558 881.967",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M325.641 589.304L117.768 708.843L268.545 971.433L476.418 851.894L325.641 589.304Z",
  fill: "#F4F5F7"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M196.111 728.17L304.018 666.199",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M187.833 757.75L331.662 675.031",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M198.576 776.379L342.405 693.66",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M209.25 795.071L353.079 712.351",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M258.927 860.673L315.856 827.941",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M266.315 873.615L323.245 840.883",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M273.706 886.49L330.636 853.758",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M981.835 971.737H449.215C437.856 971.737 428.688 962.562 428.688 951.194V599.773H1002.36V951.194C1002.36 962.562 993.194 971.737 981.835 971.737Z",
  fill: "#243045"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.36 599.773H428.688L400.839 310.529C399.676 298.477 409.119 288 421.23 288H1009.82C1021.93 288 1031.44 298.477 1030.28 310.529L1002.36 599.773Z",
  fill: "#243045"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M428.688 599.773H1002.36",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M495.197 853H451.405V874.502H495.197V853Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M478.296 684.684H451.405V706.185H478.296V684.684Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M699.515 853H569.37V874.502H699.515V853Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M677.207 890.594H569.369V957.769H677.207V890.594Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M894.527 684.684H849.982V706.185H894.527V684.684Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M867.636 715.635H849.982V737.137H867.636V753.366H894.527V737.137V715.635H867.636Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M831.233 852.999H809.748V874.5H831.233V852.999Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M867.636 852.999H846.15V874.5H867.636V852.999Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M867.636 821.431H846.15V842.933H867.636V821.431Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M901.437 852.999H879.951V874.5H901.437V852.999Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M981.493 566.629L980.398 579.708H445.315L444.151 566.629H981.493Z",
  fill: "#4F99BA"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M1003.39 311.078L991.415 450.77L988.952 480.078L981.494 566.632H444.152L433.683 444.059L430.125 402.768L422.256 311.078H1003.39Z",
  fill: "#62A8C7"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M1185.06 900.865C1208.19 853.547 1169.39 782.811 1130.87 754.736C1116.91 744.601 1100.08 737.685 1082.63 737.548C1063.4 737.411 1043.69 746.313 1033.29 762.474C1024.6 775.964 1023.03 793.151 1026.04 808.901C1029.05 824.65 1036.37 839.304 1044.38 853.205C1051.77 866.01 1059.84 878.336 1068.6 890.251C1076.33 900.728 1084.68 910.931 1095.22 918.463C1109.31 928.529 1127.38 933.391 1144.48 930.447C1161.59 927.502 1177.4 916.477 1185.06 900.865Z",
  fill: "#243045"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M1046.02 749.189L1093.85 802.053",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M1037.95 841.494L1145.37 767.334",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M1064.9 767.198C1067.71 765.144 1071.61 765.623 1073.87 768.294L1086.53 783.085C1089.2 786.235 1088.44 790.96 1084.95 793.151L1084.27 793.562C1081.39 795.342 1077.63 794.657 1075.51 791.987L1063.54 776.785C1061.21 773.772 1061.83 769.458 1064.9 767.198Z",
  fill: "#F9F9F9"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M1291.12 505.231L1072.58 588.365L1117.12 705.622L1335.66 622.487L1291.12 505.231Z",
  fill: "#F4F5F7"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M1276.58 526.327L1243.96 538.735L1251.06 557.424L1283.68 545.016L1276.58 526.327Z",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M1242.05 591.008L1293.78 571.356",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M1247.46 605.252L1299.19 585.6",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M1253.28 620.385L1304.94 600.732",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M144.393 24.2156C185.717 8.39701 232.451 10.2018 274.465 24.0563C316.479 37.9108 353.983 63.2312 386.66 93.0105C411.221 115.411 433.926 141.528 444.27 173.112C454.614 204.749 450.264 242.862 426.499 266.165C419.55 272.96 410.001 278.587 400.506 276.517C390.48 274.34 383.849 263.883 383.265 253.691C382.682 243.446 386.873 233.52 392.071 224.708C421.937 173.749 486.39 148.322 544.689 157.506C602.988 166.689 653.861 206.713 684.151 257.407C714.441 308.101 725.793 368.455 724.944 427.536",
  stroke: "#243045",
  strokeWidth: 4.1402,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.1
}, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M252 991.5L279.007 945.19L126.5 709.5L161 685L129 666.501L2.99972 868.999L252 991.5Z",
  fill: "url(#paint0_linear_240_10)"
}))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M860.549 265.452L621.052 253.538L609.048 518.903L845.308 567.866L860.549 265.452Z",
  fill: "#F4F5F7"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M676.488 312.173L800.766 318.426",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M653.523 332.574L819.239 340.809",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M652.481 354.053L818.197 362.288",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M651.346 375.547L817.062 383.783",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M703.36 215.669L478.059 297.766L570.126 546.938L806.843 500.236L703.36 215.669Z",
  fill: "#F4F5F7"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M551.924 330.249L668.863 287.713",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M538.693 357.97L694.583 301.157",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M546.079 378.166L701.97 321.353",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M553.388 398.412L709.278 341.599",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M592.159 494.368L649.089 461.637",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M599.548 507.31L656.477 474.578",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  d: "M606.938 520.185L663.868 487.453",
  stroke: "#243045",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 479,
  y: 437,
  width: 462,
  height: 131,
  fill: "#62A8C7"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M701 474H505L513 541H701V474Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M910 474H714L715 541H904L910 474Z",
  stroke: "#F9F9F9",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "M554.474 509.776L560.764 509.759L557.68 500.86L557.612 500.86L554.474 509.776ZM554.944 494.883L560.418 494.868L569.561 519.12L564.019 519.135L562.169 513.734L553.091 513.758L551.202 519.169L545.83 519.184L554.944 494.883ZM583.082 507.693C582.737 505.688 581.544 504.671 579.504 504.677C578.722 504.679 578.077 504.885 577.567 505.226C577.024 505.568 576.618 506.045 576.279 506.59C575.941 507.135 575.738 507.747 575.604 508.428C575.47 509.108 575.404 509.754 575.405 510.4C575.407 511.046 575.477 511.692 575.615 512.337C575.752 513.017 575.958 513.595 576.265 514.138C576.573 514.681 576.982 515.088 577.527 515.426C578.038 515.765 578.684 515.933 579.432 515.931C580.588 515.928 581.471 515.62 582.082 514.972C582.692 514.324 583.098 513.439 583.265 512.351L587.923 512.338C587.589 514.685 586.71 516.456 585.217 517.684C583.724 518.912 581.788 519.529 579.476 519.535C578.15 519.539 576.925 519.338 575.836 518.899C574.747 518.46 573.793 517.85 573.043 517.036C572.259 516.257 571.645 515.306 571.234 514.219C570.789 513.132 570.581 511.909 570.578 510.583C570.574 509.223 570.741 507.965 571.146 506.808C571.551 505.65 572.126 504.629 572.906 503.777C573.651 502.925 574.601 502.242 575.722 501.763C576.809 501.284 578.1 501.043 579.528 501.039C580.548 501.036 581.569 501.169 582.521 501.439C583.474 501.708 584.359 502.148 585.109 502.69C585.858 503.232 586.506 503.944 586.984 504.759C587.462 505.574 587.737 506.559 587.808 507.681L583.082 507.693ZM602.605 507.641C602.26 505.636 601.067 504.619 599.027 504.624C598.245 504.626 597.6 504.832 597.091 505.174C596.548 505.515 596.141 505.992 595.802 506.537C595.464 507.082 595.262 507.695 595.127 508.375C594.993 509.055 594.927 509.701 594.929 510.347C594.93 510.993 595 511.639 595.138 512.285C595.276 512.965 595.481 513.542 595.789 514.085C596.096 514.628 596.505 515.035 597.05 515.374C597.561 515.712 598.208 515.881 598.956 515.879C600.112 515.876 600.995 515.567 601.605 514.919C602.215 514.272 602.621 513.387 602.788 512.298L607.446 512.286C607.112 514.633 606.233 516.403 604.74 517.631C603.248 518.859 601.311 519.476 598.999 519.483C597.673 519.486 596.449 519.285 595.36 518.846C594.27 518.407 593.317 517.798 592.567 516.984C591.783 516.204 591.168 515.254 590.757 514.167C590.312 513.08 590.105 511.856 590.101 510.53C590.098 509.17 590.264 507.912 590.669 506.755C591.074 505.598 591.649 504.576 592.429 503.724C593.175 502.872 594.125 502.19 595.245 501.711C596.332 501.232 597.624 500.99 599.052 500.986C600.072 500.984 601.092 501.117 602.045 501.386C602.997 501.656 603.883 502.095 604.632 502.637C605.381 503.179 606.029 503.892 606.508 504.706C606.986 505.521 607.26 506.506 607.331 507.628L602.605 507.641ZM621.995 508.303C621.753 507.079 621.343 506.162 620.763 505.518C620.184 504.907 619.299 504.604 618.143 504.573C617.361 504.575 616.715 504.713 616.206 504.986C615.697 505.259 615.289 505.567 614.984 505.941C614.679 506.35 614.477 506.759 614.342 507.167C614.207 507.61 614.14 507.984 614.141 508.324L621.995 508.303ZM614.149 511.384C614.221 512.947 614.598 514.102 615.348 514.78C616.064 515.493 617.119 515.83 618.479 515.826C619.431 515.823 620.28 515.583 620.993 515.105C621.672 514.627 622.112 514.082 622.281 513.538L626.531 513.526C625.857 515.636 624.807 517.169 623.415 518.057C621.99 518.979 620.291 519.425 618.319 519.43C616.925 519.434 615.666 519.234 614.577 518.795C613.454 518.356 612.5 517.712 611.75 516.898C610.966 516.084 610.351 515.134 609.94 513.979C609.529 512.858 609.322 511.601 609.318 510.241C609.314 508.949 609.515 507.724 609.954 506.567C610.359 505.444 610.968 504.456 611.782 503.638C612.562 502.82 613.512 502.137 614.599 501.658C615.686 501.179 616.909 500.938 618.269 500.935C619.765 500.931 621.058 501.233 622.181 501.808C623.271 502.383 624.191 503.163 624.907 504.113C625.624 505.097 626.137 506.217 626.48 507.44C626.79 508.698 626.895 509.989 626.831 511.35L614.149 511.384ZM638.58 515.772C639.362 515.77 640.008 515.632 640.551 515.291C641.094 514.983 641.501 514.574 641.84 514.063C642.178 513.552 642.381 512.94 642.549 512.259C642.683 511.579 642.749 510.899 642.747 510.185C642.746 509.505 642.642 508.791 642.504 508.111C642.366 507.466 642.126 506.854 641.785 506.311C641.443 505.768 641 505.361 640.455 505.023C639.911 504.684 639.264 504.55 638.516 504.518C637.7 504.52 637.055 504.692 636.511 505.033C635.968 505.375 635.561 505.784 635.223 506.295C634.884 506.84 634.682 507.418 634.548 508.099C634.414 508.779 634.347 509.493 634.349 510.207C634.317 510.921 634.421 511.601 634.559 512.281C634.697 512.96 634.936 513.572 635.278 514.081C635.619 514.59 636.062 514.997 636.607 515.301C637.152 515.64 637.798 515.774 638.58 515.772ZM629.668 501.38L634.258 501.367L634.264 503.611L634.332 503.611C634.907 502.658 635.653 501.976 636.57 501.531C637.453 501.121 638.472 500.88 639.56 500.877C640.92 500.874 642.111 501.142 643.132 501.65C644.12 502.191 644.938 502.869 645.62 503.717C646.268 504.599 646.747 505.584 647.09 506.739C647.399 507.894 647.538 509.084 647.576 510.308C647.579 511.498 647.412 512.62 647.109 513.709C646.772 514.798 646.298 515.785 645.655 516.603C645.011 517.455 644.197 518.137 643.246 518.615C642.295 519.128 641.174 519.369 639.882 519.372C638.794 519.375 637.774 519.174 636.854 518.735C635.935 518.295 635.185 517.651 634.605 516.769L634.537 516.769L634.559 525.099L629.732 525.112L629.668 501.38ZM656.573 501.307L660.109 501.298L660.117 504.528L656.581 504.537L656.605 513.241C656.607 514.057 656.744 514.601 657.017 514.872C657.29 515.143 657.834 515.278 658.65 515.276C658.922 515.309 659.16 515.274 659.432 515.24C659.67 515.239 659.908 515.204 660.146 515.136L660.156 518.876C659.748 518.945 659.272 519.014 658.796 519.015C658.286 519.051 657.81 519.052 657.334 519.053C656.586 519.055 655.872 519.023 655.192 518.923C654.512 518.823 653.933 518.621 653.422 518.316C652.912 518.045 652.503 517.604 652.229 517.061C651.922 516.518 651.784 515.804 651.781 514.92L651.753 504.55L648.829 504.558L648.821 501.328L651.745 501.32L651.73 496.05L656.558 496.037L656.573 501.307Z",
  fill: "white"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  d: "M752.684 515.512H757.444C758.192 515.512 758.94 515.41 759.688 515.138C760.402 514.9 761.048 514.492 761.626 513.914C762.17 513.336 762.646 512.588 762.986 511.636C763.326 510.718 763.496 509.596 763.496 508.236C763.496 507.012 763.36 505.924 763.122 504.938C762.884 503.952 762.51 503.102 761.966 502.388C761.422 501.708 760.674 501.164 759.79 500.79C758.906 500.416 757.784 500.212 756.492 500.212H752.684V515.512ZM747.346 495.724H757.818C759.382 495.724 760.81 495.996 762.17 496.472C763.53 496.982 764.686 497.73 765.672 498.716C766.658 499.736 767.44 500.96 767.984 502.456C768.528 503.952 768.8 505.72 768.834 507.726C768.834 509.494 768.596 511.126 768.154 512.622C767.678 514.118 766.998 515.41 766.08 516.498C765.162 517.586 764.006 518.47 762.646 519.082C761.286 519.694 759.654 520 757.818 520H747.346V495.724ZM783.869 509.324C783.631 508.1 783.223 507.182 782.645 506.536C782.067 505.924 781.183 505.618 780.027 505.584C779.245 505.584 778.599 505.72 778.089 505.992C777.579 506.264 777.171 506.57 776.865 506.944C776.559 507.352 776.355 507.76 776.219 508.168C776.083 508.61 776.015 508.984 776.015 509.324H783.869ZM776.015 512.384C776.083 513.948 776.457 515.104 777.205 515.784C777.919 516.498 778.973 516.838 780.333 516.838C781.285 516.838 782.135 516.6 782.849 516.124C783.529 515.648 783.971 515.104 784.141 514.56H788.391C787.711 516.668 786.657 518.198 785.263 519.082C783.835 520 782.135 520.442 780.163 520.442C778.769 520.442 777.511 520.238 776.423 519.796C775.301 519.354 774.349 518.708 773.601 517.892C772.819 517.076 772.207 516.124 771.799 514.968C771.391 513.846 771.187 512.588 771.187 511.228C771.187 509.936 771.391 508.712 771.833 507.556C772.241 506.434 772.853 505.448 773.669 504.632C774.451 503.816 775.403 503.136 776.491 502.66C777.579 502.184 778.803 501.946 780.163 501.946C781.659 501.946 782.951 502.252 784.073 502.83C785.161 503.408 786.079 504.19 786.793 505.142C787.507 506.128 788.017 507.25 788.357 508.474C788.663 509.732 788.765 511.024 788.697 512.384H776.015ZM803.529 508.61C803.189 506.604 801.999 505.584 799.959 505.584C799.177 505.584 798.531 505.788 798.021 506.128C797.477 506.468 797.069 506.944 796.729 507.488C796.389 508.032 796.185 508.644 796.049 509.324C795.913 510.004 795.845 510.65 795.845 511.296C795.845 511.942 795.913 512.588 796.049 513.234C796.185 513.914 796.389 514.492 796.695 515.036C797.001 515.58 797.409 515.988 797.953 516.328C798.463 516.668 799.109 516.838 799.857 516.838C801.013 516.838 801.897 516.532 802.509 515.886C803.121 515.24 803.529 514.356 803.699 513.268H808.357C808.017 515.614 807.133 517.382 805.637 518.606C804.141 519.83 802.203 520.442 799.891 520.442C798.565 520.442 797.341 520.238 796.253 519.796C795.165 519.354 794.213 518.742 793.465 517.926C792.683 517.144 792.071 516.192 791.663 515.104C791.221 514.016 791.017 512.792 791.017 511.466C791.017 510.106 791.187 508.848 791.595 507.692C792.003 506.536 792.581 505.516 793.363 504.666C794.111 503.816 795.063 503.136 796.185 502.66C797.273 502.184 798.565 501.946 799.993 501.946C801.013 501.946 802.033 502.082 802.985 502.354C803.937 502.626 804.821 503.068 805.569 503.612C806.317 504.156 806.963 504.87 807.439 505.686C807.915 506.502 808.187 507.488 808.255 508.61H803.529ZM811.22 495.724H816.048V520H811.22V495.724ZM824.814 499.702H819.986V495.724H824.814V499.702ZM819.986 502.422H824.814V520H819.986V502.422ZM828.615 502.422H833.205V504.87H833.307C833.919 503.85 834.701 503.136 835.687 502.66C836.639 502.184 837.659 501.946 838.679 501.946C839.971 501.946 841.025 502.15 841.841 502.49C842.657 502.83 843.337 503.34 843.813 503.952C844.289 504.564 844.595 505.346 844.799 506.23C845.003 507.114 845.105 508.1 845.105 509.188V520H840.277V510.072C840.277 508.644 840.039 507.556 839.597 506.842C839.121 506.128 838.339 505.754 837.183 505.754C835.857 505.754 834.905 506.162 834.327 506.944C833.715 507.726 833.443 509.018 833.443 510.786V520H828.615V502.422ZM860.602 509.324C860.364 508.1 859.956 507.182 859.378 506.536C858.8 505.924 857.916 505.618 856.76 505.584C855.978 505.584 855.332 505.72 854.822 505.992C854.312 506.264 853.904 506.57 853.598 506.944C853.292 507.352 853.088 507.76 852.952 508.168C852.816 508.61 852.748 508.984 852.748 509.324H860.602ZM852.748 512.384C852.816 513.948 853.19 515.104 853.938 515.784C854.652 516.498 855.706 516.838 857.066 516.838C858.018 516.838 858.868 516.6 859.582 516.124C860.262 515.648 860.704 515.104 860.874 514.56H865.124C864.444 516.668 863.39 518.198 861.996 519.082C860.568 520 858.868 520.442 856.896 520.442C855.502 520.442 854.244 520.238 853.156 519.796C852.034 519.354 851.082 518.708 850.334 517.892C849.552 517.076 848.94 516.124 848.532 514.968C848.124 513.846 847.92 512.588 847.92 511.228C847.92 509.936 848.124 508.712 848.566 507.556C848.974 506.434 849.586 505.448 850.402 504.632C851.184 503.816 852.136 503.136 853.224 502.66C854.312 502.184 855.536 501.946 856.896 501.946C858.392 501.946 859.684 502.252 860.806 502.83C861.894 503.408 862.812 504.19 863.526 505.142C864.24 506.128 864.75 507.25 865.09 508.474C865.396 509.732 865.498 511.024 865.43 512.384H852.748Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.2
}, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  d: "M713.728 282.103L792.001 437.003L848.001 437.002L862.001 282.102L713.728 282.103Z",
  fill: "url(#paint1_linear_240_10)"
}))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  d: "M918.003 437L915.041 450H502L498.979 437H918.003Z",
  fill: "#62A8C7"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  d: "M471.341 1027L328.999 1015.55C332.911 1007.01 356.432 961.155 356.835 959.501C369.513 909.206 407.899 833.946 416.133 818.171C421.456 807.98 425.598 797.712 437.252 793.562C448.035 789.731 453.164 801.21 451.009 810.4C454.665 806.129 458.119 801.609 461.625 797.21C464.467 793.618 467.43 789.975 471.341 787.559C475.253 785.143 480.355 784.187 484.45 786.289C490.397 789.381 491.729 797.531 490.122 804.049C488.555 810.549 484.873 816.459 483.52 823.013C488.308 815.297 493.667 807.914 499.534 800.94C502.234 797.695 505.334 794.377 509.487 793.439C516.306 791.902 522.996 797.888 524.793 804.645C526.591 811.402 520.192 827.217 518.491 833.965C530.204 817.585 545.967 791.74 558.493 775.926C564.28 768.65 569.369 760.855 574.799 753.299C579.557 746.649 584.787 736.689 593.935 736.132C597.29 735.914 600.803 737.208 602.827 739.849C605.379 743.176 605.179 747.808 604.281 751.92C601.776 763.46 595.448 775.128 589.708 785.352C575.968 809.864 561.888 834.136 548.876 859.011C539.501 876.848 532.58 894.941 524.395 913.328C531.676 908.007 538.958 902.685 546.199 897.381C548.607 895.599 551.033 893.858 553.015 891.634C555.206 889.226 556.833 886.386 558.575 883.593C568.295 868.052 583.864 842.768 604.253 841.396C606.716 841.219 609.309 841.465 611.293 842.878C612.256 843.572 612.986 844.509 613.531 845.572C614.527 847.593 614.721 850.096 614.198 852.374C613.443 855.804 611.433 858.758 609.465 861.695C606.842 865.577 604.311 869.565 601.879 873.559C594.817 884.962 588.401 896.763 582.639 908.863C579.256 915.938 576.811 924.102 572.143 930.284C567.649 936.2 561.247 941.677 555.997 947.051C533.735 970.084 509.248 991.135 481.322 1006.98C476.993 1009.43 472.341 1011.68 469.185 1015.55C467.652 1017.25 493.713 983.912 471.341 1027Z",
  fill: "#C96959"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  d: "M581.615 750.855C580.199 754.42 579.838 758.784 582.172 761.821C584.977 765.52 590.895 765.704 594.738 763.125C599.965 759.628 605.388 747.289 599.516 742.107C593.044 736.412 583.89 745.012 581.615 750.855Z",
  fill: "white"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  d: "M603.989 869.366C603.691 868.773 603.44 868.065 603.305 867.404C601.773 859.913 605.305 848.993 611.705 846.007C612.07 845.852 612.436 845.698 612.802 845.544C613.631 847.396 613.844 849.604 613.462 851.536C612.936 854.486 611.352 856.973 609.849 859.426C607.821 862.675 605.867 865.988 603.989 869.366Z",
  fill: "white"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M413.811 991.792L482.634 997.478L471.069 1030L413.811 991.792Z",
  fill: "url(#paint2_linear_240_10)"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  d: "M1049.89 904.215C1050.04 899.482 1053.83 894.792 1058.52 893.136C1064.43 891.066 1071 892.626 1076.83 895.048C1098.12 903.955 1113.15 923.039 1131.96 936.417C1132.51 936.802 1133.04 937.145 1133.59 937.53C1128.86 928.304 1124.28 918.993 1119.47 909.789C1111.77 895.115 1101.38 882.582 1092.98 868.583C1083.2 852.253 1074.4 834.776 1065.33 817.946C1062.71 813.114 1060.06 808.024 1060.01 802.547C1060 797.06 1063.59 791.138 1069.06 790.559C1073.97 790.041 1078.21 793.818 1081.64 797.37C1101.45 817.92 1119.85 845.133 1134.22 869.177C1122.65 849.121 1112.7 827.835 1100.56 808.329C1095.05 799.49 1079.02 774.52 1095.96 768.519C1099.16 767.397 1102.77 768.156 1105.7 769.849C1108.64 771.543 1110.99 774.055 1113.19 776.653C1123.06 788.22 1131.67 801.323 1139.84 814.143C1144.11 820.835 1148.28 827.642 1152.74 834.196C1156.84 840.269 1163.5 846.278 1166.73 852.717C1155.21 829.725 1143.73 806.681 1132.25 783.678C1129.12 777.433 1125.94 770.847 1126.38 763.91C1126.54 761.522 1127.23 758.989 1129.09 757.516C1132.05 755.174 1136.45 756.562 1139.71 758.479C1150.63 764.717 1158.39 775.168 1165.59 785.504C1178.73 804.298 1191.04 823.667 1202.51 843.485C1196.95 824.076 1188.69 805.479 1178.04 788.365C1173.43 780.88 1168.23 773.55 1166.03 765.018C1165.51 763.077 1165.21 760.945 1165.9 759.076C1167.47 755.025 1173.01 754.206 1177.2 755.473C1184.54 757.757 1189.85 764.037 1194.54 770.131C1240.86 829.977 1257.67 880.506 1291.07 947.8L1325 1018.11L1194.54 1032L1186.13 1018.11L1185.89 1017.73C1165.23 1014.15 1139.84 992.261 1122.36 975.604C1105.21 959.346 1087.62 943.915 1070.33 927.96C1065.21 923.222 1060.13 918.473 1055.06 913.589C1053.32 911.886 1051.48 910.164 1050.52 907.898C1050.02 906.703 1049.83 905.471 1049.89 904.215Z",
  fill: "#C96959"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  d: "M950.87 543.37L917 542L936.433 570.349L940.949 561.927L960.245 572.267L965.65 562.201L946.354 551.861L950.87 543.37Z",
  fill: "#243045"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_240_10",
  x1: 244.869,
  y1: 881.854,
  x2: 155.212,
  y2: 963.135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.148362,
  stopColor: "#384272"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_240_10",
  x1: 735.031,
  y1: 350.825,
  x2: 838.661,
  y2: 288.331,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.148362,
  stopColor: "#384272"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_240_10",
  x1: 449.235,
  y1: 982.468,
  x2: 427.265,
  y2: 1018.61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E87D5C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A889",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStudentMoreTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/studentMoreTime.e9ec12d959ac9209821cec37163cbab1.svg";